<div *ngIf="!timedOut">
    <h1 mat-dialog-title>{{ 'SessionTimeOutTitle' | translate }}</h1>
    <div mat-dialog-content>
        {{ 'SessionTimeOutCurrentState' | translate }}{{ idleState }}{{ 'SessionTimeOutSeconds' | translate }}
    </div>
    <div mat-dialog-actions style="float:right;">
        <button mat-button cdkFocusInitial (click)="onStaySignedInClick()" class="te-button-blue">{{ 'SessionTimeOutStaySignedIn' | translate }}</button>
    </div>
</div>
<div *ngIf="timedOut">
    <h1 mat-dialog-title>{{ 'SessionTimeOutExpired' | translate }}</h1>
    <div mat-dialog-content>
        {{ 'SessionTimeOutLoginAgain' | translate }}
    </div>
    <div mat-dialog-actions style="float:right;">
        <button mat-button cdkFocusInitial [disableRipple]="true" class="te-button-blue" (click)="onReloadClick()">{{ 'SessionTimeOutLogin' | translate }}</button>
    </div>
</div>